<template>
  <div class="content">
   <div class="flower"></div>
   <div class="mian">
          <div class="headersLOGO">
       <div class="headers-left"></div>
       <div class="headers-right">
          <div class="headers-img"></div>
       </div>
    </div>
    <div class="moneyBox">
      <div class="moneyIMG"></div>
    </div>
    <div class="periodImg"></div>
    <div class="boxPhone">
       <div class="boxtip">*Masukkan nomor ponsel Anda untuk mendapatkan batas kredit</div>
       <div class="inputPhone">
         <img src="@/assets/landingPage/phone.png" alt="" style="width:0.64rem;height:0.64rem;">
         <!--     @paste="keyupPaste('paste', $event)" -->
         <!--      @keyup="keyupPaste('key', $event)"-->
         <input
          type="tel"
          ref="mobile"
          @input="phoneInput"
          v-model.trim="phone"
          @copy="onCopy"
           @keyup="keyupPaste('key', $event)"
                @paste="keyupPaste('paste', $event)"
                @keydown="onKeydown"
            :maxlength="maxLength"
          placeholder="Contoh : 080000000000"
         class="phone"
         >
       </div>
       <div class="code" @click="goLogin">
         <div class="code-left">
         <van-count-down :time="time">
            <template #default="timeData">
               <span class="block">{{formatTime(timeData.minutes)  }}</span>
               <span class="colon">:</span>
               <span class="block">{{formatTime(timeData.seconds) }}</span>
            </template>
        </van-count-down>
         </div>
         <div class="code-right">
            Segera ajukan pinjaman
         </div>
       </div>
    </div>
    <div class="centerBOX">
    </div>
    <div class="swipeBox">
       <div class="swipeTitle"></div>
       <div class="swipelist">
      <Swipe
         :autoplay="3000"   class="my-swipe" >
         <SwipeItem v-for="(image, index) in imagesList" :key="index" >
            <div class="itemSwipe">
               <div class="itemTOP">
                  <div class="topleft">
                     <img :src="image.picture" alt="" style="width: 0.7467rem;height: 0.7467rem;">
                     <div class="leftBox">
                         <div class="leftName">{{image.name}}</div>
                         <div class="leftTime">{{image.time}}</div>
                     </div>
                  </div>
                  <img src="@/assets/landingPage/Path.png" alt="" style="width: 0.7467rem;height:0.56rem">
               </div>
               <div class="itemCenter">
                  <img src="@/assets/landingPage/star.png" alt="" style="width: 0.4533rem;height: 0.4533rem;margin-right: 0.08rem;" v-for="(itme,index) in 5" :key="index">
               </div>
               <div class="itemBottom">{{image.text}}</div>
            </div>
         </SwipeItem>
       </Swipe>

       </div>

    </div>
    <div class="aboutBOX">
       <div class="aboutTitle"></div>
       <div class="aboutText">

          <div class="textTip">Untuk informasi lebih lanjut, hubungi</div>
          <div class="textTip" style="margin-bottom: 0.2667rem;">kami di:</div>
          <div class="textName">Telepon: 021-83782891/2</div>
          <div class="textName" style="margin-bottom: 0.2667rem;">E-mail: cs@cashcepat.co.id</div>
         <div class="textTip" style="margin-bottom: 0.2667rem;">Company registration address:</div>
          <div class="textName">Blue Bird Office Tower, 6th Floor</div>
          <div class="textName">Mampang Prapatan Raya St. No.60, RT.9/RW.3,</div>
          <div class="textName">Tegal Parang, Mampang Prapatan, South Jakarta</div>
          <div class="textName" style="margin-bottom: 0.2667rem;"> City, Jakarta 12790</div>
         <div class="textTip">Untuk informasi lebih lanjut, silakan</div>
          <div class="textTip" style="margin-bottom: 0.2667rem;">kunjungi situs web resmi kami</div>
         <div class="textName" style="text-decoration: underline;">https://cashcepat.id/</div>
       </div>

    </div>
    <div class="bottomProtocol">
        <div class="topProtocol">Berizin dan Diawasi Oleh OJK</div>
        <div class="centerProtocol"></div>
        <div class="btProtocol">
           <div class="bttext" style="margin-right: 0.2667rem;">Desclaimer resiko</div>
           <div class="bttext">Kebijakan Privasi</div>
        </div>
    </div>

   </div>

  </div>
</template>

<script>
//  Toast,
import { Swipe, SwipeItem } from 'vant'
// import { register } from './lib'

// import agreeMent from '@/components/agreeMent.vue'
export default {
  name: 'fraudPrevention',
  components: { Swipe, SwipeItem },
  data () {
    return {
      title: '',
      phone: localStorage.getItem('phone') || '',
      maxLength: 27,
      time: 61 * 1000,
      imagesList: [
        {
          picture: require('@/assets/landingPage/title1.png'),
          name: 'Aang Anwar',
          time: '24/02/2025',
          text: 'Alhamdulillah sangat membantu kami ketika adakeperluan mendadak karena aplikasi ini sangat cepatmerespon dan akses semua data yang telah kami isisebagaimana …'
        },
        {
          picture: require('@/assets/landingPage/title2.png'),
          name: 'Affdolussholawat',
          time: '23/02/2025',
          text: 'MUDAH CEPAT TERNYATA... TIDAK SULIT SEPERTI YANGDIBAYANGKAN'
        },
        {
          picture: require('@/assets/landingPage/title3.png'),
          name: 'Wisnu Dinata',
          time: '23/02/2025',
          text: 'Simpel dan tidak ribet,lebih gampang di mengerti,amanah dan terpercaya'
        },
        {
          picture: require('@/assets/landingPage/title4.png'),
          name: 'Hadijah ija',
          time: '24/02/2025',
          text: 'Saya sangat senang dengan aplikasi ini,sangatmembantu sekali,the best'
        }
      ]
    }
  },
  watch: {

  },
  methods: {
    formatTime (time) {
      return String(time).padStart(2, '0')
    },
    async goLogin () {
      // const loadingInstance = Toast.loading(
      //   {
      //     message: '',
      //     duration: 0,
      //     forbidClick: true,
      //     closeOnClick: false
      //   }
      // )
      // const res = await register({
      //   phone: this.phone,
      //   deviceNo: localStorage.getItem('deviceNo')
      // })
      // console.log(res)

      // if (res.code === '200') {
      //   loadingInstance.clear()
      //   if (!res.data.registered) {
      //     this.$store.dispatch('updateLandingPage', 'yes')
      //     this.$router.replace({ name: 'Register' })
      //   }
      //   // this.$router.replace({ name: 'Register' })
      // }
    },
    keyupPaste (key, e) {
      this.validateInput(e.target.value)
      this.formatMobile(e)
      this.phone = this.$refs.mobile.value
    },
    getValue (e, val) {
      let value = ''
      if (e.type === 'keyup') {
        value = val.replace(/\D/g, '')
      } else if (e.type === 'paste') {
        // window.clipboardData：IE
        // event.clipboardData：Chrome, Firefox, Safari
        const clipboardData = e.clipboardData || window.clipboardData

        event.preventDefault()
        value = clipboardData.getData('text/plain') //      text
        value = value.replace(/\D/g, '')
        console.log('   ', value)
      }
      return value
    },
    validateInput (value) {
      //
      value = value.replace(/\s/g, '')
      //
      if (/^08\d{9,21}$/.test(value)) {
        this.maxLength = 24 // 08  ，  10-20
      } else if (/^8\d{8,20}$/.test(value)) {
        this.maxLength = 23 // 8  ，  9-19
      } else if (/^6208\d{8,24}$/.test(value)) {
        this.maxLength = 27 // 6208  ，  12-22
      } else if (/^628\d{9,22}$/.test(value)) {
        this.maxLength = 25 // 628  ，  11-21
      } else if (/^\d{9,}$/.test(value)) {
        this.maxLength = 27 //     ，9-19
      }
    },
    onCopy (event) {
      //
      const selection = window.getSelection().toString()

      //
      const modifiedText = selection.replace(/\s+/g, '') //

      //
      event.preventDefault()

      //
      if (event.clipboardData) {
        event.clipboardData.setData('text/plain', modifiedText)
      } else {
        //    Clipboard API    ，     document.execCommand
        document.execCommand('copy', false, modifiedText)
      }
    },
    onKeydown (e) {
      const input = e.target
      const selectionLeft = input.value.substring(
        input.selectionStart - 1,
        input.selectionEnd
      )
      const selectionRight = input.value.substring(
        input.selectionStart,
        input.selectionEnd + 1
      )

      //     ，
      const selectionStart = input.selectionStart
      if (e.keyCode === 8 && selectionLeft === ' ' && selectionRight) {
        input.selectionStart = selectionStart - 1
        input.selectionEnd = input.selectionStart
        e.preventDefault()
      }
    },
    formatMobile (e) {
      const val = this.$refs.mobile.value

      const selStart = this.$refs.mobile.selectionStart
      const mobileLen = val.length

      let value = this.getValue(e, val).substr(0, this.maxLength - 4) //     /    ,    20
      console.log(value, 'value')

      const len = value.length
      if (len > 4) {
        //          4
        value = value.replace(/(\d{4})(?=\d)/g, '$1 ')
      }
      this.$refs.mobile.value = value

      if (selStart !== mobileLen) {
        //
        this.$refs.mobile.selectionStart = this.$refs.mobile.selectionEnd =
          selStart
      }
      const aa = this.$refs.mobile.value.replace(/\D/g, '')
      if (aa.length === 24) {
        // alert(aa.length) //
      }
    },
    phoneInput (val) {
      localStorage.setItem('phone', this.phone)
    }
  },

  // },
  mounted () {
  }

}
</script>

<style lang="less" scoped>
.van-count-down{
                font-weight: 600;
                font-size: 0.5267rem;
                color: #FFFFFF;
}
.content{
 height: 100%;
  background: url('@/assets/landingPage/landingPageBG.png') no-repeat center/100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  z-index: 1;
.flower{
   width: 100%;
   height: 6.1867rem;
   top: 0.1867rem;
    z-index: 2;
   position: absolute;
    background: url('@/assets/landingPage/flower.png') no-repeat center/100% 100%;
}
  .mian{
    z-index: 3;
   padding: 0.2667rem 0.3733rem 0 0.3733rem;
    width: 100%;
    height: 100%;
   //  height:100vh;
    overflow:auto;
               .headersLOGO{
            width: 100%;
            padding: 0 0.2933rem 0 0.0533rem;
            margin-bottom: 0.5867rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .headers-left{
               width: 2.8rem;
               height: 0.7467rem;
               background: url('@/assets/landingPage/logo.png') no-repeat center/100% 100%;
            }
            .headers-right{
               width: 3.0667rem;
               height: 0.6933rem;
               display: flex;
               align-items: center;
               justify-content: center;
               border-radius: 0.3467rem;
               background: linear-gradient( 359deg, #F5FEE9 0%, #F5FEE9 66%, #FFFFFF 100%);
               border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.31)) 2 2;
               .headers-img{
                  width: 2.48rem;
                  height: 0.48rem;
                  background: url('@/assets/landingPage/afpibg.png') no-repeat center/100% 100%;
               }
            }
         }
         .moneyBox{
           width:100%;
            height: 2.56rem;
            padding: 0 0.2933rem;
            .moneyIMG{
                width:8.9333rem;
                height: 2.56rem;
                background: url('@/assets/landingPage/money.png') no-repeat center/100% 100%;
         }
         }

         .periodImg{
            width: 100%;
            height: 4.1067rem;
            background: url('@/assets/landingPage/period.png') no-repeat center/100% 100%;
         }
         .boxPhone{
            margin-top: -0.6133rem;
            margin-bottom: 0.2667rem;
            padding: 0.88rem 0.56rem 0.56rem 0.56rem;
            width: 100%;
            height: 5.7333rem;
            background: linear-gradient( 359deg, #F5FEE9 0%, #F5FEE9 66%, #FFFFFF 100%);
            border-radius: 0.5867rem;
            .boxtip{
               // font-family: NotoSans, NotoSans;
               font-size: 0.32rem;
               color: #00880C;
               text-align: left;
               font-weight: 500;
               font-style: normal;
               margin-bottom: 0.2933rem;
            }
            .inputPhone{
            padding: 0 0.32rem;
            margin-bottom: 0.4267rem;
            width:100%;
            height: 1.3867rem;
            display: flex;
            align-items: center;
            border: 0.0267rem solid #00880C;
            border-radius:0.6933rem;
            background: #F4F6F8;
            .phone{
               height: 0.5067rem;
               background: #F4F6F8;
               width:100%;
                border-radius:0.6933rem;
               font-size:0.44rem;
               font-weight: 600;
               color: #0E2E28;
               // font-family: NotoSans, NotoSans;
               padding: 0.3633rem 0 0.393rem 0;
               text-align: left;
               outline: none;
               border: none;
            }
              .phone::placeholder {
                  font-weight: 400;
                  font-size:0.4267rem ;
                  color: #b8b9c1;
                   }

            }
            .code{
               background: url('@/assets/landingPage/code.png') no-repeat center/100% 100%;
               width: 100%;
               height: 1.44rem;
               padding: 0 0.3067rem 0 0.44rem;
               display: flex;
                 animation: btnSize 2s infinite;
                 animation-delay: 1s;
               align-items: center;
               justify-content: space-between;
               .code-left{
                font-weight: 600;
                font-size: 0.5867rem;
                color: #FFFFFF;
               //  font-family: PingFangSC, PingFang SC;

               }
               .code-right{
                  font-family: "SemiBold", sans-serif;
                  font-weight: 600;
                  font-size: 0.38rem;
                  color: #FFFFFF;

               }
            }
         }
         .centerBOX{
            width: 100%;
            height: 2.1333rem;
            margin-bottom: 0.2667rem;
            background: url('@/assets/landingPage/centerBG.png') no-repeat center/100% 100%;
         }
         .swipeBox{
             width: 100%;
             padding-top: 0.48rem;
            height: 6.8267rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            background: url('@/assets/landingPage/Swipe.png') no-repeat center/100% 100%;
            .swipeTitle{
               width: 4.48rem;
               height: 0.6133rem;
               margin-bottom: 0.5067rem;
                background: url('@/assets/landingPage/swipeTitle.png') no-repeat center/100% 100%;
            }
            .swipelist{
               padding-bottom: 0.5333rem;
               overflow: hidden;
            }
            .itemSwipe{
               padding: 0.3267rem 0.3733rem 0.3467rem 0.3733rem;
               width:8rem;

               height: 4.32rem;
               display: flex;
               flex-direction: column;
               // justify-content: space-between;
               border-radius: 0.2667rem;
               background: #FFFFFF;
               .itemTOP{
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 0.2667rem;
                  .topleft{
                     display: flex;
                     align-items: center;
                     .leftBox{
                        margin-left: 0.08rem;
                        display: flex;
                        flex-direction: column;
                        .leftName{
                        //   font-family: NotoSans, NotoSans;
                          font-weight: 500;
                          font-size:0.3467rem;
                          color: #0E2E28;
                        }
                        .leftTime{
                           text-align: left;
                           // font-family: NotoSans, NotoSans;
                           font-weight: 400;
                           font-size: 0.2667rem;
                           color: #9F9F9F;

                        }
                     }
                  }

               }
               .itemCenter{
                  display: flex;
                  margin-bottom: 0.1033rem;
               }
               .itemBottom{
                  // font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 0.30rem;
                  color: #9F9F9F;
                  text-align: left;
               }
            }
         }
         .aboutBOX{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 0.2667rem;
            width:100%;
            height: 8.5067rem;
            background: url('@/assets/landingPage/tentangBG.png') no-repeat center/100% 100%;
            padding: 0.48rem 0.48rem 0 0.48rem;
            .aboutTitle{
               width: 3.9467rem;
               height: 0.6133rem;
               margin-bottom: 0.4rem;
               background: url('@/assets/landingPage/aboutTip.png') no-repeat center/100% 100%;
            }
            .aboutText{
               width: 100%;
               display: flex;
               flex-direction: column;
               .textTip{
                  text-align: left;
                  line-height:0.4rem;
                  // font-family: Poppins, Poppins;
                  font-weight: 500;
                  font-size: 0.34rem;
                  color: #0E2E28;
               }
               .textName{
                  text-align: left;
                  // font-family: NotoSans, NotoSans;
                  font-weight: 500;
                  font-size:0.34rem;
                  color: #00880C;
               }
            }
         }
         .bottomProtocol{
            width: 100%;
            height: 2.0667rem;
            margin:0.7733rem 0 1.4133rem 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            .topProtocol{
               // font-family: NotoSans, NotoSans;
               font-weight:400;
               font-size: 0.32rem;
               color: #0E2E28;
               font-style: normal;
            }
            .centerProtocol{
               margin: 0.2133rem 0 0.3733rem 0;
                background: url('@/assets/landingPage/bottombg.png') no-repeat center/100% 100%;
               width: 3.0933rem;
               height: 0.5867rem;
            }
            .btProtocol{
               display: flex;
               justify-content: space-between;
               .bttext{
                  // font-family: NotoSans, NotoSans;
                  font-weight: 400;
                  font-size:0.32rem;
                  font-style: normal;
                  color: #0E2E28;
                  text-decoration: underline;
               }
            }
         }

  }

}
.van-swipe {
width: 8rem;
 overflow: visible;

}
.van-swipe__indicators {
  transform: translateX(-54%) translateY(0.8rem) !important;
}
::v-deep .van-swipe__indicator--active {
  width: 0.5333rem !important;
  border-radius: 0.5333rem  !important;
  background-color: #83BE3D !important;
}
// ::v-deep .van-swipe-item{
// width: 7.4667rem !important;
// }
::v-deep .van-swipe__indicators {
  position: absolute;
  bottom: -0.5333rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
@keyframes btnSize {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }

}

</style>
